import { provideTransloco, translocoConfig } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco.loader';

export function provideI18n() {
    return provideTransloco({
        config: translocoConfig({
            availableLangs: ['pt-BR', 'en-US', 'es-ES'],
            defaultLang: 'pt-BR',
            fallbackLang: 'pt-BR',
            reRenderOnLangChange: true,
        }),
        loader: TranslocoHttpLoader,
    });
}
